import { CnxIdType } from '@cnx-saas/utils-cnx-id';
import {
  BaseFilterOne,
  BaseFilterMany,
  BaseQueryMany,
  DateTimeRange,
  NumberRange,
} from '@cnx-saas/common';
import { Order, OrderStatus, OrderType, Orders } from './Order';
import { Location } from './Location';
import { LoadArticle, LoadStatus } from './Load';

export class FilterOrder extends BaseFilterOne(CnxIdType.Order) {
  articleId?: string;
  loadId?: string;
}

export class FilterOrders extends BaseFilterMany(CnxIdType.Order) {}

export class OrderArticleFilters {
  ids?: string[];
  weightInKg?: NumberRange;
  loadingMillimeter?: NumberRange;
}

export class OrderLoadFilters {
  ids?: string[];
  status?: LoadStatus[];
}

export class OrderFilters {
  ids?: string[];
  externalReference?: string;
  customerOrderReference?: string;
  type?: OrderType;
  status?: OrderStatus[];
  articleIds?: string[];
  locationIds?: string[];
  deadline?: DateTimeRange;
  article?: OrderArticleFilters;
  load?: OrderLoadFilters;
}
export class QueryOrders extends BaseQueryMany<OrderFilters>() {}

export interface OrderQueryVariables {
  filter: FilterOrder;
}
export interface OrderQueryResult {
  order: Order;
  loadIds: string[];
}

export interface OrdersQueryVariables {
  query: QueryOrders;
}
export interface OrdersQueryResult {
  orders: Orders;
}

export interface OrdersByExternalReferencesQueryVariables {
  externalReferences: string[];
}

export type MatchOrder = {
  articles: LoadArticle[];
  matchedLocation: Location;
};
